import React from 'react'
import styles from './style.module.scss'
import CustomLink from '@shared/components/customLink'
import PropTypes from 'prop-types'
import { Container } from 'react-bootstrap'

import MyImage from '@shared/components/myImage'
import { BLUR_DATA_URL_BASE64, S3_PREFIX } from '@shared-submodule/sm-constants'
import Slider from '@shared/components/slider'
import TeamPlaceholder from '@assets/images/placeholder/team-placeholder.svg'
import useWindowSize from '@shared/hooks/windowSize'

export default function PopularTeams({ popularTeams }) {
  const [width] = useWindowSize()
  return (
    <div className={styles.popularTeams}>
      <Container className={`${styles.root}`}>
        <h1 className={`${styles.title}`}>
          Trending Teams
        </h1>
        {/* <div className={`${styles.slider} d-flex scroll-list flex-nowrap text-nowrap`}> */}
        <Slider
          gap={12}
          nav
          className="align-items-center"
          destroyBelow={1199}
          customNextArrow={styles.customNextArrow}
          customPrevArrow={styles.customPrevArrow}>
          {popularTeams?.map(team => (
            <CustomLink key={team?._id} href={`/${team.oSeo.sSlug}`} prefetch={false}>
              <a className={`${styles.item} d-flex flex-column`}>
                <div className={`${styles.img} d-block m-auto`}>
                  <MyImage
                    src={team.oImg.sUrl ? `${S3_PREFIX}${team.oImg.sUrl}` : TeamPlaceholder}
                    blurDataURL={BLUR_DATA_URL_BASE64}
                    placeholder="blur"
                    width="90"
                    height="90"
                    alt={team.oImg.sUrl}
                    errorImage={TeamPlaceholder}
                  />
                </div>
                <span className={styles.teamName}>{width > 767 ? team?.sTitle : team?.sAbbr}</span>
              </a>
            </CustomLink>
          ))}
        </Slider>
        {/* </div> */}
      </Container>
    </div>
  )
}

PopularTeams.propTypes = {
  popularTeams: PropTypes.array
}
